import req from "../../axios/interceptedAxiosInstance";
import AddressInput from "../form-input/address-input/AddressInput";
import { useState } from "react";
import { successToast } from "../../notification/notification";

const Address = ({
  address,
  getUserAddress,
  toggleBackdrop,
  setEditFirstname,
  setEditLastname,
  setEditEmail,
  setEditPhonenumber,
  setEditAddress,
  setEditCity,
  setEditState,
  setEditedAddressID,
  setSelection,
  setSelectedAddress,
}) => {
  
  const [loading, setLoading] = useState(false);

  const addressOption = (e) => {
    setSelection(e.target.value);
    setSelectedAddress(e.target.value);
  };

  const openEdit = () => {
    toggleBackdrop();
    setEditFirstname(address.first_name);
    setEditLastname(address.last_name);
    setEditEmail(address.email);
    setEditPhonenumber(address.phone_number);
    setEditAddress(address.address);
    setEditCity(address.city);
    setEditState(address.state);
    setEditedAddressID(address.id);
  };

  const deleteAddress = async () => {
    setLoading(true);
    try {
      const response = await req.delete(`address/delete/${address.id}`);
      successToast(response?.data?.message);
      getUserAddress();
      setLoading(false);
    } catch (error) {
      console(error);
      setLoading(false);
    }
  };
  return (
    <div className="mt-3">
      <div className="w-full md:w-[500px] lg:w-[600px] xl:w-addressWidth h-addressHeight flex justify-between items-center bg-white p-3">
        <div className="flex items-center gap-2 xl:gap-4">
          <AddressInput
            value={address.address}
            onchange={addressOption}
            name="address"
          />
          <p className="font-bold text-xs xl:text-sm">{address.address}</p>
        </div>
        <div className="flex gap-1 xl:gap-2 items-center">
          <button
            className="text-addressMobile xl:text-sm text-logoRed"
            onClick={openEdit}
          >
            Edit Address
          </button>
          <p>|</p>
          <button
            className="text-xs xl:text-sm text-logoRed"
            disabled={loading}
            onClick={deleteAddress}
          >
            Delete Address
          </button>
        </div>
      </div>
    </div>
  );
};

export default Address;
